export default class FormNaturefund {
  constructor(element) {
    this.customAmountFields = element.querySelectorAll('.valKies_zelf')
    if (!this.customAmountFields) {
      return
    }

    // On nextstep click:
    element.querySelector('.js-nextsteptrigger').addEventListener('click', (event) => {
      this.nextStep(event)
      this.amountchoiceChange() // Trigger amountchoiceChange after nextStep to be sure it is set
    })

    // On submit click:
    element.querySelector('input.js-submit').addEventListener('click', (event) => this.submitButtonClick(event))

    this.element = element

    this.unitPrice = element.querySelector('form').getAttribute('data-unitprice')
    this.unitName = element.querySelector('form').getAttribute('data-unitname')

    this.amountChoice = element.querySelector('.js-amountchoice')
    this.amountcalculation = element.querySelector('.js-amountcalculation')

    this.amountChoice.addEventListener('change', (event) => this.amountchoiceChange(event))

    this.init()

    // Ensure the form state is correctly restored after a browser back action:
    window.addEventListener('pageshow', () => this.restoreFormState())
  }

  restoreFormState() {
    const checkedRadio = this.amountChoice.querySelector('.radio:checked')
    if (checkedRadio) {
      const amountValue = checkedRadio.value
      const customAmoundfield = this.amountChoice.querySelector('input.customamoundfield')

      if (amountValue === 'Kies zelf' && customAmoundfield) {
        const customValue = parseFloat(customAmoundfield.value || 0)
        this.updateChoiceDisplay(customValue * this.unitPrice, customValue)
      } else {
        const amountUnits = amountValue / this.unitPrice
        this.updateChoiceDisplay(amountValue, amountUnits)
      }
    }
  }

  updateChoiceDisplay(amountValue, amountUnits) {
    amountValue = parseFloat(amountValue)
    const amountUnitElement = this.amountcalculation.querySelector('.js-amountcalculation-unit')
    const amountValueElement = this.amountcalculation.querySelector('.js-amountcalculation-value')

    if (parseInt(amountUnits)) {
      amountUnitElement.innerHTML = parseInt(amountUnits).toLocaleString('nl-NL') + ' ' + this.unitName
    } else {
      amountUnitElement.innerHTML = '... ' + this.unitName
    }

    amountValueElement.innerHTML =
      '€ ' + amountValue.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }

  amountchoiceChange(event) {
    const amountValue = this.amountChoice.querySelector('.radio:checked').value
    const amountUnits = amountValue / this.unitPrice
    const customAmoundfield = this.amountChoice.querySelector('input.customamoundfield')
    const customUnitsAmount = this.element.querySelector('input.js-customunitsamount')

    if (amountValue === 'Kies zelf' && customAmoundfield) {
      this.updateChoiceDisplay(customAmoundfield.value * this.unitPrice, customAmoundfield.value)
      customUnitsAmount.value = customAmoundfield.value + ' ' + this.unitName
    } else {
      this.updateChoiceDisplay(amountValue, amountUnits)
      customUnitsAmount.value = amountUnits + ' ' + this.unitName
    }
  }

  isOtheramountValid() {
    let otherAmountSelected = this.element.querySelector('.js-amountchoice .valKies_zelf input:checked')

    if (otherAmountSelected) {
      const otherAmountSelectedValue = this.element.querySelector('input.customamoundfield').value
      const minAllowedValue = 1
      const maxAllowedValue = 100000

      const berekendeprice = parseFloat(otherAmountSelectedValue * this.unitPrice)

      // Cap price at 5000 max (minus 7,5 extras)
      if (
        otherAmountSelectedValue < minAllowedValue ||
        otherAmountSelectedValue > maxAllowedValue ||
        berekendeprice > 4992.5
      ) {
        this.element.querySelector('.js-customamounterror').classList.add('is--active')
        document.getElementById('customamounterror').scrollIntoView({ behavior: 'smooth', block: 'center' })
        return false
      } else {
        this.element.querySelector('.js-customamounterror').classList.remove('is--active')
        return true
      }
    } else {
      this.element.querySelector('.js-customamounterror').classList.remove('is--active')
      return true
    }
  }

  submitButtonClick(event) {
    event.preventDefault()

    if (this.isOtheramountValid() && this.validateNawFields()) {
      const submitButton = this.element.querySelector('input.js-submit')
      submitButton.disabled = true
      submitButton.value = 'Wordt verzonden...'

      window.dataLayer.push({
        event: 'natuurfonds_donatie',
        stap: 'stap 2',
        stap_naam: 'voltooid',
      })

      this.element.querySelector('.js-naturefunds-form > form').submit()
    } else {
      let errorInputs = this.element.querySelectorAll('.js-error input')

      errorInputs[0].closest('.field').scrollIntoView({ behavior: 'smooth', block: 'center' })

      errorInputs.forEach((el) => {
        el.addEventListener('change', () => {
          this.validateNawFields()
        })
      })
    }
  }

  nextStep() {
    window.dataLayer.push({
      event: 'natuurfonds_donatie',
      stap: 'stap 1',
      stap_naam: 'bedrag',
    })

    if (this.isOtheramountValid()) {
      this.element.querySelector('.js-nextsteptrigger').classList.add('hidden')

      const nextstep = this.element.querySelector('.js-formsection--naw')
      nextstep.classList.add('is--active')

      document.getElementById('NAW').scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  validateNawFields() {
    let validation = true

    // Reset all error classes:
    let oldErrorClasses = this.element.querySelectorAll('.js-error')

    oldErrorClasses.forEach((el) => {
      el.classList.remove('js-error')
    })

    // All required text fields:
    const requiredTextFields = this.element.querySelectorAll('.js-formsection--naw .field.text.is--required input')
    requiredTextFields.forEach((el) => {
      if (!el.value) {
        validation = false

        el.closest('.field').classList.add('js-error')
      }
    })

    // All required checkboxes:
    const requiredCheckFields = this.element.querySelectorAll('.js-formsection--naw .field.checkbox.is--required input')
    requiredCheckFields.forEach((el) => {
      if (!el.checked) {
        validation = false

        el.closest('.field').classList.add('js-error')
      }
    })

    // Custom zipcode validation
    const requiredZipcodeField = this.element.querySelector(
      '.js-formsection--naw .field.js-validate-zipcode.is--required input.js-validate-zipcode'
    )
    if (requiredZipcodeField) {
      const zipcodeRegEx = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i

      if (!zipcodeRegEx.test(requiredZipcodeField.value)) {
        validation = false

        requiredZipcodeField.closest('.field').classList.add('js-error')
      }
    }

    // Custom email validation
    const requiredEmailField = this.element.querySelector(
      '.js-formsection--naw .field.js-validate-email.is--required input.js-validate-email'
    )
    if (requiredEmailField) {
      const emailRegEx =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (!emailRegEx.test(requiredEmailField.value)) {
        validation = false

        requiredEmailField.closest('.field').classList.add('js-error')
      }
    }

    if (validation) {
      return true
    } else {
      return false
    }
  }

  init() {
    this.amountchoiceChange()
    if (
      this.element.querySelector('.message.required') &&
      !this.element.querySelector('.js-nextsteptrigger').classList.contains('hidden')
    ) {
      this.nextStep()
    }

    this.customAmountFields.forEach((customAmountField) => {
      const newInputElement = document.createElement('input')
      newInputElement.type = 'number'
      newInputElement.min = '11'
      newInputElement.autocomplete = 'off'
      newInputElement.placeholder = this.unitName

      newInputElement.classList.add('customamoundfield')

      customAmountField.append(newInputElement)

      customAmountField.addEventListener('click', (event) => {
        newInputElement.focus()
      })

      newInputElement.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !this.element.querySelector('.js-nextsteptrigger').classList.contains('hidden')) {
          event.preventDefault()
          this.nextStep()
        }
        // Prevent invalid characters:
        if (['-', 'e', 'E', '.', ',', '+'].includes(event.key)) {
          event.preventDefault()
        }
      })

      newInputElement.addEventListener('mousewheel', (event) => {
        event.preventDefault()
        this.element.blur()
      })

      newInputElement.addEventListener('input', () => {
        const amountValue = newInputElement.value * this.unitPrice
        const amountUnits = newInputElement.value

        // Update inputs:
        this.element.querySelector('input.js-customvalue').value = amountValue

        // Update display:
        this.updateChoiceDisplay(amountValue, amountUnits)
      })

      addEventListener('paste', (event) => {
        event.preventDefault()
      })
    })

    // Call restoreFormState to sync state at initialization:
    this.restoreFormState()
  }
}
